import React from 'react';
import { Typography, Grid, Paper, List, ListItem, ListItemText, Divider } from '@mui/material';

const Home = ({data}) => {

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Notifications
      </Typography>
      <Grid container spacing={3}>
        {/* Upcoming Assignments (Notifications) */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>Upcoming Assignments</Typography>
            <List>
              <ListItem>
                <ListItemText
                  primary="📚 Mock Test: Science"
                  secondary="🗓️ Due: 15th October, 2024"
                />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="📚 Math Homework: Algebra"
                  secondary="🗓️ Due: 20th October, 2024"
                />
              </ListItem>
              {/* Add more notifications for assignments here */}
            </List>
          </Paper>
        </Grid>

        {/* Recent Announcements (Notifications) */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>Recent Announcements</Typography>
            <List>
              <ListItem>
                <ListItemText
                  primary="📢 Admissions Open"
                  secondary="🗓️ Apply before 30th November, 2024"
                />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="📢 Parent-Teacher Meeting"
                  secondary="🗓️ Scheduled: 18th October, 2024"
                />
              </ListItem>
              {/* Add more announcements here */}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default Home;
